// Reservation.jsx
import React from 'react';
import { FaInstagram, FaEnvelope } from 'react-icons/fa'; // Instagramとメールアイコンをインポート

const Reservation = () => {
  return (
    <div id="reservation" className="bg-white p-6 border-t border-black max-w-4xl mx-auto mt-8 pt-16" style={{ fontFamily: 'notsans, serif' }}>
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 font-serif tracking-wide uppercase" style={{ fontFamily: 'Hatton, serif' }}>
        Order
      </h2>
      <p className="text-xs  text-gray-700 text-center mb-6" style={{ fontFamily: 'zenmaru, serif' }}>
        ご予約方法を以下からお選びください
      </p>

      {/* Buttons for Reservation Methods */}
      <div className="flex flex-col items-center space-y-4" style={{ fontFamily: 'zenmaru, serif' }}>
        {/* Instagram Reservation */}
        <a
          href="https://www.instagram.com/_cerise.m_/?igsh=N2JleHFxYzNmZGVj"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-sm flex items-center justify-center bg-gray-800 text-white py-3 px-6 font-bold text-lg shadow-md hover:bg-gray-700 transition"
        >
          <FaInstagram className="mr-3 text-3xl" />
          インスタグラムで予約
        </a>

        {/* Email Reservation */}
        <a
          href="mailto:cerise.wedding.14@gmail.com"
          className="w-full max-w-sm flex items-center justify-center bg-gray-800 text-white py-3 px-6 font-bold text-lg shadow-md hover:bg-gray-700 transition"
        >
          <FaEnvelope className="mr-3 text-2xl" />
          メールで予約
        </a>
      </div>

      {/* Additional Information */}
      <p className="text-xs  text-gray-600 text-center mt-6" style={{ fontFamily: 'zenmaru, serif' }}>
        ご質問やご相談がございましたら いつでもお気軽にお問い合わせください
      </p>
    </div>
  );
};

export default Reservation;
